<template>
<!-- 索赔预设数据 -->
  <div class="order">
    <search @handleSearch="handleSearch" />
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="text"
          icon="el-icon-plus"
          @click="handleAddOrEdit('新增')"
          >新增</el-button
        >
        <!-- :loading="exportLoading" -->
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport"
          >导出</el-button
        >
      </div>
      <!-- v-loading="loading" -->
      <el-table
        :data="tableData"
        highlight-current-row
        border
        stripe
      >
        <el-table-column
          type="selection"
          width="40"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="presetDataId"
          label="索赔后台数据单号"
          :min-width="$getColumnWidth('presetDataId',tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerAccountNum"
          label="关联客户账号"
          min-width="160px"
        >
        </el-table-column>

        <el-table-column
          prop="customerCountry"
          label="国家"
          width="130"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <p>{{ getCountry(scope.row.customerCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerCompanyName"
          label="公司"
          min-width="280px"
        >
        </el-table-column>
        <el-table-column
          prop="claimUnitPrice"
          label="索赔工时单价"

          :min-width="$getColumnWidth('claimUnitPrice',tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="claimManagementRate"
          label="索赔管理费费率"

          :min-width="$getColumnWidth('claimManagementRate',tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="currency"
          label="结算币种"

          :min-width="$getColumnWidth('currency',tableData)"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency === 0 ? "CNY" : scope.row.currency === 1 ? "USD" : "RUB" }}
          </template>
        </el-table-column>
        <el-table-column
          label="有效期"
          width="200"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime + " ~ " + scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <p :class="'status' + scope.row.status">
              {{ getStatus(scope.row.status) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="cancelTime"
          label="作废时间"
          width="160"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              size="mini"
              type="text"
              @click="handleAddOrEdit('编辑', scope.row)"
              >修改</el-button
            >
            <el-popconfirm
              title="是否确认启用"
              placement="top"
              @confirm="handleChangeStatus(scope.row)"
              v-if="scope.row.status == 0"
            >
              <el-button
                slot="reference"
                size="mini"
                type="text"
                style="margin-left:10px"
                >启用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否确认作废"
              placement="top"
              @confirm="handleChangeStatus(scope.row)"
              v-if="scope.row.status == 1"
            >
              <el-button slot="reference" size="mini" type="text"
                >作废</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <pre-set-dialog ref="preSetDialog" @success="getList" />
  </div>
</template>
<script>
import { presetList, changeStatus, presetExport } from "@/api/seek";
import search from "@/components/preSearch";
import { getNations } from "@/util/getNation";
import { getDownloadFiles } from "@/util/downFile";
import PreSetDialog from "./preSetDataDialog.vue";

export default {
  components: {
    search,
    PreSetDialog
  },
  data() {
    return {
      tableData: [],
      status: "",
      page: 1,
      pageSize: 10,
      total: 0,
      searchInfo: {},
      // loading: false,
      // exportLoading: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取状态
    getStatus(data) {
      let status;
      if (data == 0) status = "未启用";
      if (data == 1) status = "已启用";
      if (data == 2) status = "已作废";
      if (data == 3) status = "已过期";
      return status;
    },
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      let obj = data;
      obj.customerCountry == "0"
        ? (this.searchInfo.customerCountry = "")
        : (this.searchInfo.customerCountry = obj.customerCountry);
      this.searchInfo.presetDataId = data.presetDataId;
      this.searchInfo.customerAccountNum = data.customerAccountNum;
      this.searchInfo.customerCompanyName = data.customerCompanyName;
      this.searchInfo.currency = data.currency;
      this.searchInfo.status = data.status;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    // 获取列表
    async getList() {
      // this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await presetList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.loading = false;
      }
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 新增
    handleAddOrEdit(title, row = {}) {
      this.$refs.preSetDialog.init(title, row);
    },
    // 导出
    async handleExport() {
      // this.exportLoading = true;
      let query = {
        data: {
          ...this.searchInfo
        }
      };
      const res = await presetExport(query);
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！");
      }
      // this.exportLoading = false;
    },
    // 启用，作废
    async handleChangeStatus(row) {
      // this.loading = true;
      await changeStatus({
        data: {
          presetDataId: row.presetDataId,
          status: row.status == 0 ? 1 : 2
        }
      });
      this.getList();
      this.$DonMessage.success(`${row.status == 0 ? "启用" : "作废"}成功`);
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
// .table-container {
//   padding: 0 7px 0 23px;
// }
.number {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline #409eff;
}
.status1 {
  color: #08b849;
}
.status2 {
  color: #ff0000;
}
.status3 {
  color: #4084ff;
}
</style>
